export default __webpack_public_path__ + "static/media/linkedinWhite.0bbbd099.svg";